import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconTeamSmall(props: IconSmallProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path
        d="M6.00016 9.16671C4.44016 9.16671 1.3335 9.94671 1.3335 11.5V12.6667H10.6668V11.5C10.6668 9.94671 7.56016 9.16671 6.00016 9.16671ZM6.00016 8.00004C7.28683 8.00004 8.3335 6.95337 8.3335 5.66671C8.3335 4.38004 7.28683 3.33337 6.00016 3.33337C4.7135 3.33337 3.66683 4.38004 3.66683 5.66671C3.66683 6.95337 4.7135 8.00004 6.00016 8.00004ZM10.6935 9.20671C11.4668 9.76671 12.0002 10.5134 12.0002 11.5V12.6667H14.6668V11.5C14.6668 10.1534 12.3335 9.38671 10.6935 9.20671ZM10.0002 8.00004C11.2868 8.00004 12.3335 6.95337 12.3335 5.66671C12.3335 4.38004 11.2868 3.33337 10.0002 3.33337C9.64016 3.33337 9.30683 3.42004 9.00016 3.56671C9.42016 4.16004 9.66683 4.88671 9.66683 5.66671C9.66683 6.44671 9.42016 7.17337 9.00016 7.76671C9.30683 7.91337 9.64016 8.00004 10.0002 8.00004Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
